import {useBlocker as useBlockerTanStack} from '@tanstack/react-router'
import {useEffect, useRef} from 'react'

interface LegacyBlocker {
  (tx: {retry(): void}): void
}

/**
 * This bridges a legacy blocker implementation for Code View's `BlobEditor`
 * Once Code View is fully migrated to DataRouter, this should be removed in favor of useBlocker.
 *
 * @deprecated - Prefer useBlocker
 */
export function useBlockerLegacy(blocker: LegacyBlocker, message: string, when = true) {
  const handledBlockedStateRef = useRef(false)

  const {status, proceed, reset} = useBlockerTanStack({
    shouldBlockFn: () => when,
    enableBeforeUnload: () => when && Boolean(message),
    withResolver: true,
  })

  useEffect(() => {
    if (status !== 'blocked') {
      handledBlockedStateRef.current = false
      return
    }

    if (handledBlockedStateRef.current) {
      return
    }

    handledBlockedStateRef.current = true

    let didRetry = false

    // Show blocker prompt
    blocker({
      retry() {
        didRetry = true
        // proceed with navigation if user confirms
        proceed?.()
      },
    })

    // If retry was not requested, cancel and stay on current route.
    if (!didRetry) {
      reset?.()
    }
  }, [blocker, proceed, reset, status])
}
